import { useEffect, useRef } from 'react';

export default function useScrollOnToggle(visible, containerRef) {
    const ref = useRef(null);
    useEffect(() => {
        if (visible && ref.current && containerRef?.current) {
            const container = containerRef.current;
            const containerRect = container.getBoundingClientRect();
            const elementRect = ref.current.getBoundingClientRect();
            const offset = elementRect.top - containerRect.top + container.scrollTop;
            container.scrollTo({ top: offset, behavior: 'smooth' });
        }
    }, [visible, containerRef]);
    return ref;
}
